import { PRD3011_R01InspectDto } from './Dto_PRD3011_R01';

export interface AggregatedInspectBadQty {
	totalQty: number;
	minBadCaseQty: number;
	badCaseQtyMap: Map<string, number>;
}

/** badCase 기준으로 badQty를 합산한다. */
export const aggregateInspectListByBadCase = (
	inspectList: PRD3011_R01InspectDto[],
	deletedValueIndexes: number[] = [],
): AggregatedInspectBadQty => {
	const badCaseQtyMap = new Map<string, number>();

	inspectList
		.filter(inspect =>
			!deletedValueIndexes.includes(inspect.valueIndex) &&
			!!inspect.badCase
		)
		.forEach(item => {
			const qty = Number(item.badQty) || 0;
			badCaseQtyMap.set(item.badCase, (badCaseQtyMap.get(item.badCase) || 0) + qty);
		});

	const aggregatedQtyList = Array.from(badCaseQtyMap.values());
	const totalQty = aggregatedQtyList.reduce((sum, qty) => sum + qty, 0);
	const minBadCaseQty = aggregatedQtyList.length > 0
		? Math.min(...aggregatedQtyList)
		: 0;

	return { totalQty, minBadCaseQty, badCaseQtyMap };
};

export interface ValidateEditBadQtyResult {
	valid: boolean;
	message?: string;
}

/** editPRD3011_R01.badQty가 집계된 불량내역 수량 범위 내인지 검증한다. */
export const validateEditBadQtyAgainstInspectList = (
	editBadQty: number,
	inspectList: PRD3011_R01InspectDto[],
	deletedValueIndexes: number[] = [],
): ValidateEditBadQtyResult => {
	const { totalQty, minBadCaseQty, badCaseQtyMap } = aggregateInspectListByBadCase(
		inspectList,
		deletedValueIndexes,
	);

	if (badCaseQtyMap.size === 0) {
		return { valid: true };
	}

	if (editBadQty > totalQty) {
		return {
			valid: false,
			message: `불량수량은 불량내역 총수량(${totalQty})을 초과할 수 없습니다.`,
		};
	}

	if (editBadQty < minBadCaseQty) {
		return {
			valid: false,
			message: `불량수량은 불량내역 사유별 최소 수량(${minBadCaseQty})보다 작을 수 없습니다.`,
		};
	}

	return { valid: true };
};
